
export { default as Carousel } from './Carousel';
export { default as Accordion } from './Accordion';
export { default as Icon } from './Icon';
export { default as Recaptcha } from './Recaptcha';
export { default as ScrollToTop } from './ScrollToTop';
export { default as Testimonial } from './Testimonial';
export { default as Testimonials } from './Testimonials';



// WEBPACK FOOTER //
// ./client/components/index.js